import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import usersService from "../../../services/users.service";
import { useEyeconxStore } from "../../../store/eyeconxStore";

import { toast } from 'react-toastify';
import { useNavigate } from "react-router-dom";
const PasswordUpdateComponent = () => {
    const [showPassword, setShowPassword] = useState({
        oldPassword: false,
        newPassword: false,
        confirmPassword: false
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitMessage, setSubmitMessage] = useState({ type: '', text: '' });

    const clinicId = useEyeconxStore((state) => state.user.clinicId);
    const userId = useEyeconxStore((state) => state.user.ID);
    const logout = useEyeconxStore((state) => state.logout);
    const navigate = useNavigate();
    const {
        register,
        handleSubmit,
        watch,
        formState: { errors },
        reset
    } = useForm({
        mode: 'onChange'
    });

    const newPassword = watch('newPassword');

    // Toggle password visibility
    const togglePasswordVisibility = (field) => {
        setShowPassword(prev => ({
            ...prev,
            [field]: !prev[field]
        }));
    };
    const handleLogout = () => {
        logout();
        navigate("/login");
    };
    // Form submission handler
    const onSubmit = async (data) => {
        setIsSubmitting(true);
        setSubmitMessage({ type: '', text: '' });

        try {
            const apiData = {
                oldPassword: data.oldPassword,
                newPassword: data.newPassword
            };

            // Replace with your actual API endpoint
           /* const response = await fetch('/api/update-password', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(apiData),
            });

            */
            const response = await usersService.changePassword(clinicId,userId, apiData);

            if (response.status === 200) {
                setSubmitMessage({
                    type: 'success',
                    text: 'Password updated successfully!'
                });
                reset();
                toast.success('Password updated successfully! Logging out in 3 seconds...');
                setTimeout(() => {
                    handleLogout();
                }, 3000);


            } else {
                const errorData = await response.json();
                setSubmitMessage({
                    type: 'danger',
                    text: errorData.message || 'Failed to update password. Please try again.'
                });
                toast.error(errorData.message || 'Failed to update password. Please try again.');
            }
        } catch (error) {
            const errorMessage =
                error?.response?.data?.message ||
                error?.response?.data?.error ||
                'An error occurred. Please check your connection and try again.';
            setSubmitMessage({
                type: 'danger',
                text: errorMessage
            });
            toast.error(errorMessage);
        } finally {
            setIsSubmitting(false);
        }
    };

    // Password strength indicator
    const getPasswordStrength = (password) => {
        if (!password) return { strength: 0, label: '' };

        let strength = 0;
        if (password.length >= 8) strength++;
        if (/[A-Z]/.test(password)) strength++;
        if (/[a-z]/.test(password)) strength++;
        if (/[0-9]/.test(password)) strength++;
        if (/[^A-Za-z0-9]/.test(password)) strength++;

        const labels = ['Very Weak', 'Weak', 'Fair', 'Good', 'Strong', 'Very Strong'];
        return { strength, label: labels[strength] };
    };

    const passwordStrength = getPasswordStrength(newPassword);

    return (

            <div className="row justify-content-center mt-3">
                <div className="col-6">
                    <div className="card shadow mt-0">

                        <div className="card-body">
                            {submitMessage.text && (
                                <div className={`alert alert-${submitMessage.type} alert-dismissible fade show`}>
                                    {submitMessage.text}
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={() => setSubmitMessage({ type: '', text: '' })}
                                    ></button>
                                </div>
                            )}

                            <form onSubmit={handleSubmit(onSubmit)}>
                                {/* Current Password Field */}
                                <div className="mb-3">
                                    <label htmlFor="oldPassword" className="form-label">
                                        Current Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.oldPassword ? 'text' : 'password'}
                                            className={`form-control ${errors.oldPassword ? 'is-invalid' : ''}`}
                                            id="oldPassword"
                                            {...register('oldPassword', {
                                                required: 'Current password is required',
                                                minLength: {
                                                    value: 8,
                                                    message: 'Password must be at least 8 characters'
                                                }
                                            })}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('oldPassword')}
                                        >
                                            <i className={`bi ${showPassword.oldPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                        </button>
                                        {errors.oldPassword && (
                                            <div className="invalid-feedback">
                                                {errors.oldPassword.message}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* New Password Field */}
                                <div className="mb-3">
                                    <label htmlFor="newPassword" className="form-label">
                                        New Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.newPassword ? 'text' : 'password'}
                                            className={`form-control ${errors.newPassword ? 'is-invalid' : ''}`}
                                            id="newPassword"
                                            {...register('newPassword', {
                                                required: 'New password is required',
                                                minLength: {
                                                    value: 8,
                                                    message: 'Password must be at least 8 characters'
                                                },
                                                validate: {
                                                    hasUpperCase: value => /[A-Z]/.test(value) || 'Must contain at least one uppercase letter',
                                                    hasLowerCase: value => /[a-z]/.test(value) || 'Must contain at least one lowercase letter',
                                                    hasNumber: value => /[0-9]/.test(value) || 'Must contain at least one number',
                                                    notSameAsOld: value => value !== watch('oldPassword') || 'New password must be different from current password'
                                                }
                                            })}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('newPassword')}
                                        >
                                            <i className={`bi ${showPassword.newPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                        </button>
                                        {errors.newPassword && (
                                            <div className="invalid-feedback">
                                                {errors.newPassword.message}
                                            </div>
                                        )}
                                    </div>

                                    {/* Password Strength Indicator */}
                                    {newPassword && (
                                        <div className="mt-2">
                                            <div className="progress" style={{ height: '5px' }}>
                                                <div
                                                    className={`progress-bar ${
                                                        passwordStrength.strength <= 2 ? 'bg-danger' :
                                                            passwordStrength.strength <= 3 ? 'bg-warning' :
                                                                passwordStrength.strength <= 4 ? 'bg-info' : 'bg-success'
                                                    }`}
                                                    style={{ width: `${(passwordStrength.strength / 5) * 100}%` }}
                                                ></div>
                                            </div>
                                            <small className={`text-${
                                                passwordStrength.strength <= 2 ? 'danger' :
                                                    passwordStrength.strength <= 3 ? 'warning' :
                                                        passwordStrength.strength <= 4 ? 'info' : 'success'
                                            }`}>
                                                Strength: {passwordStrength.label}
                                            </small>
                                        </div>
                                    )}
                                </div>

                                {/* Confirm New Password Field */}
                                <div className="mb-4">
                                    <label htmlFor="confirmPassword" className="form-label">
                                        Confirm New Password
                                    </label>
                                    <div className="input-group">
                                        <input
                                            type={showPassword.confirmPassword ? 'text' : 'password'}
                                            className={`form-control ${errors.confirmPassword ? 'is-invalid' : ''}`}
                                            id="confirmPassword"
                                            {...register('confirmPassword', {
                                                required: 'Please confirm your new password',
                                                validate: value => value === newPassword || 'Passwords do not match'
                                            })}
                                        />
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary"
                                            onClick={() => togglePasswordVisibility('confirmPassword')}
                                        >
                                            <i className={`bi ${showPassword.confirmPassword ? 'bi-eye-slash' : 'bi-eye'}`}></i>
                                        </button>
                                        {errors.confirmPassword && (
                                            <div className="invalid-feedback">
                                                {errors.confirmPassword.message}
                                            </div>
                                        )}
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <div className="d-grid">
                                    <button
                                        type="submit"
                                        className="btn btn-primary text-white"
                                        disabled={isSubmitting}
                                    >
                                        {isSubmitting ? (
                                            <>
                                                <span className="spinner-border spinner-border-sm me-2" role="status"></span>
                                                Updating Password...
                                            </>
                                        ) : (
                                            <>
                                                <i className="bi bi-key me-2"></i>
                                                Update Password
                                            </>
                                        )}
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>

                    {/* Password Requirements */}
                    <div className="card mt-3">
                        <div className="card-body">
                            <h6 className="card-title">
                                <i className="bi bi-info-circle me-2"></i>
                                Password Requirements
                            </h6>
                            <ul className="list-unstyled small mb-0">
                                <li>
                                    <i className="bi bi-check-circle text-success me-2"></i>
                                    At least 8 characters long
                                </li>
                                <li>
                                    <i className="bi bi-check-circle text-success me-2"></i>
                                    Contains uppercase and lowercase letters
                                </li>
                                <li>
                                    <i className="bi bi-check-circle text-success me-2"></i>
                                    Includes at least one number
                                </li>
                                <li>
                                    <i className="bi bi-check-circle text-success me-2"></i>
                                    Different from current password
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>

    );
};

export default PasswordUpdateComponent;